export default __webpack_public_path__ + "static/media/buildings_tab.f7a7e321.png";